import styled from "styled-components";

export const V3ECOWrapper = styled.div<{ $active: boolean }>`
    border: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
    padding: 12px 16px 16px;
    border-radius: 8px;
    cursor: pointer;
    outline: ${({ theme, $active }) => $active ? `2px solid  ${theme.v3.colors.blue}` : undefined};

    &:hover { 
        outline:  ${({ theme }) => theme ? `2px solid  ${theme.v3.colors.blue}` : undefined};
    }
`;

export const V3ECORadioWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;